import { Flex, Spinner } from "@chakra-ui/react";
import axios from "axios";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../lib/accountContext";
import { useRedirectToLogin } from "../../lib/hooks";
import toast, { Toaster } from 'react-hot-toast';
import Nav from "../NavBar";

export default function SubscribeRedirect() {
  const navigate = useNavigate();

  const checkout = async () => {
    const res = await axios
      .post("/create-payment-checkout-session")
      .catch((e) => {
        console.error(e);
        toast.error("Sorry, we had an issue creating a checkout session. Please try again later.")
      });
    if (res.data?.alreadySubscribed) {
      navigate("/");
      toast.success("You are already subscribed!")
    } else if (res.data) {
      // Replace URL in case the user presses the back button after redirect
      window.history.replaceState(null, "", "/");
      window.location.href = res.data.checkoutUrl;
    }
  };

  const user = useUser();
  useRedirectToLogin();

  useEffect(() => {
    if (user) checkout();
  }, [user]);

  return (
    <Flex direction={"column"} minH={"100vh"}>
      <Nav />
      <Spinner mx="auto" my={36} size={"xl"} />
      <Toaster
        position="top-center"
        reverseOrder={false}
      />
    </Flex>
  );
}
